import React from 'react'

import { Modal } from 'antd'
import PT from 'prop-types'

const ConfirmModal = ({
  cancelText,
  children,
  okButtonProps,
  okText,
  onCancel,
  onConfirm,
  title,
  visible,
}) => (
  <Modal
    bodyStyle={children ? undefined : { padding: 0 }}
    cancelText={cancelText}
    centered
    closable={false}
    okButtonProps={okButtonProps}
    okText={okText}
    onCancel={onCancel}
    onOk={onConfirm}
    title={title}
    visible={visible}
  >
    {children}
  </Modal>
)

ConfirmModal.defaultProps = {
  cancelText: 'No',
  children: null,
  okButtonProps: {},
  okText: 'Yes',
}

ConfirmModal.propTypes = {
  cancelText: PT.string,
  children: PT.node,
  okButtonProps: PT.object,
  okText: PT.string,
  onCancel: PT.func.isRequired,
  onConfirm: PT.func.isRequired,
  title: PT.node.isRequired,
  visible: PT.bool.isRequired,
}

export default ConfirmModal
